import { ModalHeaderWizardComponent } from './../modal-header-wizard/modal-header-wizard.component';
import { NgModule } from '@angular/core';
import { HeaderComponent } from './header.component';
import { ShowRightHeaderContainerPipe } from './pipes/show-right-header-container.pipe';
import { ExpiredCreditsTooltipPipe } from './pipes/expired-credits-tooltip.pipe';

export const headerComponentDeclarations: NgModule['declarations'] = [
    HeaderComponent,
    ModalHeaderWizardComponent,
    ShowRightHeaderContainerPipe,
    ExpiredCreditsTooltipPipe,
];
